'use client';

import { c as _c } from "react/compiler-runtime";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { cs } from 'date-fns/locale/cs';
type ClientLocalizationProviderProps = {
  children: React.ReactNode;
};
export const ClientLocalizationProvider = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={cs}>{children}</LocalizationProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};